<div class="card" style="max-width: 800px; margin: 2rem auto;">
    <h4>Teste — mentioned_comment</h4>

    <div class="mb-3 text-sm text-color-secondary">
        <div><b>store_id:</b> 1</div>
        <div><b>comment_id:</b> 18000060554947294</div>
        <div><b>ig_user_id:</b> 17841451256341069</div>
    </div>

    <div class="flex gap-2 mb-3 flex-wrap">
        <button pButton label="mentioned_comment (+ from + owner)" [loading]="loading" (click)="testMentionedComment()"></button>
        <button pButton label="GET /{comment-id} direto" class="p-button-outlined" [loading]="loading" (click)="testDirectComment()"></button>
        <button pButton label="mentioned_media (legenda sem comment_id)" class="p-button-success" [loading]="loading" (click)="testMentionedMedia()"></button>
        <button pButton label="Página FB vinculada ao IG" class="p-button-secondary" [loading]="loading" (click)="testLinkedPage()"></button>
        <button pButton label="POST comentário via mentions (hardcoded)" class="p-button-warning" [loading]="loading" (click)="testCommentViaMentions()"></button>
        <button pButton label="GET filhos carousel (3 variações)" class="p-button-danger" [loading]="loading" (click)="testCarouselChildren()"></button>
    </div>

    <pre *ngIf="result" class="mt-3"
        style="background: #1e1e1e; color: #d4d4d4; padding: 1rem; border-radius: 6px; overflow: auto; font-size: 0.8rem;">{{ result | json }}</pre>

    <pre *ngIf="error" class="mt-3"
        style="background: #3b1212; color: #f87171; padding: 1rem; border-radius: 6px; overflow: auto; font-size: 0.8rem;">{{ error }}</pre>
</div>
